<template>
    <div class="animated fadeIn">        
        <b-card>
            <div slot="header">
                Return Customer Form
            </div>
              <b-row>
                <b-col md="6">
                    <b-input-group >
                    <b-input-group-prepend><label>Customer</label></b-input-group-prepend>
                    <b-form-input  v-model="model.customer" :state="!$v.model.customer_id.$error" @change="customerChange"></b-form-input>
                    <b-input-group-append>
                    <b-btn text="Button" @click="lkuCustomerShow=true" >
                        <i class="fa fa-search"></i>
                    </b-btn>
                    </b-input-group-append>
                        <b-input-group-append><button class="btn btn-success ml-2" @click="openDelivery"><i class="fa fa-play"></i> Open</button></b-input-group-append>
                    </b-input-group>                                        
                </b-col>
                <b-col md="4">
                    <b-input-group >
                        <b-input-group-prepend><span class="p-2">Retur By</span></b-input-group-prepend>
                          <b-form-input v-model="model.salesretur" placeholder="Nama Sales Retur" ></b-form-input>
                    </b-input-group>                                        
                </b-col>    
              </b-row>
              <b-card no-body class="mb-1">
                <b-table-simple hover small responsive bordered>                    
                    <b-thead head-variant="light">
                        <b-tr>
                            <b-th sticky-column style="width:295px;" variant="light" >Item</b-th>
                            <b-th style="width:100px;" variant="light" >Sale Price</b-th>
                            <b-th style="text-align:center;width:50px;" v-for="kol in daterange" :key="kol.kode">{{kol.tanggal}}</b-th>
                        </b-tr>
                    </b-thead>
                    <b-tbody>
                        <b-tr  v-for="(row,idx) in ordLines.items" :key="row.podtlkey">
                            <b-th sticky-column>
                                <div style="font-weight: normal !important; ">{{idx+1}}. {{row.itemname}} </div>
                            </b-th>
                            <td style="text-align:right;"> {{uanguser}} {{row.unitprice | numFormat}}</td>
                            <b-td v-for="kol in daterange" :key="kol.kode" style="padding:0 !important;">
                                  <input  :min="0" v-model="row[`Q${kol.kode}`]" type="number" style="width:100%;" disabled v-b-tooltip.hover title="Qty.Deliver" class="text-right"/>
                                  <input :min="0" v-model="row[`R${kol.kode}`]" type="number" style="width:100%;" v-b-tooltip.hover title="Qty.RETUR" class="text-right"/>
                            </b-td>
                        </b-tr>
                        </b-tbody>
                    </b-table-simple>

              </b-card>    
            <b-row class="justify-content-center mt-1">
                <div style="width:500px;">
                    <b-input-group >
                        <b-input-group-prepend><span class="p-2">Retur By</span></b-input-group-prepend>
                      <b-form-input v-model="model.salesretur" placeholder="Nama Sales Retur" ></b-form-input>
                        <b-input-group-append>
                            <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                        </b-input-group-append>
                        <b-input-group-append>
                            <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </b-row>

        </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
        <b-modal v-model="lkuCustomerShow" size="lg" :hide-footer="true" title="List of Customer" :centered="true">
            <lku-customer @click="onSelectLkuCustomer"></lku-customer>
        </b-modal>        

    </div>
</template>
<style lang="scss">
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 130px;
            }
        }
    }
    .form-group {
        margin-bottom:2px;
        .input-group {
            padding-bottom:0;
        }
    }
    .row-details-form {
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 80px;
            }
        }
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
    }
</style>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import moment from 'moment';
import myNumber from "../../components/my-number";
import lkuCustomer from "../lookup/lkuCustomer";
import retur from "../../apis/bakeryreturcustomer";
import { validationMixin } from "vuelidate";
import { required, numeric, decimal } from "vuelidate/lib/validators";
toastr.init();

export default {   
  components: { Loading, myNumber, lkuCustomer},
  mixins: [validationMixin],
  validations: {
        model: {
            customer_id: { required },
            tgl1: { required },
            tgl2: { required }
        },
  }, 
  data() {
    return {
        saveEnabled:true,
          isLoading:false,
      inputBerlanjut: 0,
      inputLineBerlanjut: 1,
      lkuCustomerShow:false,
        tahun:(this.$store.state.user.tglaktif || '').substring(0,4),
        uanguser: this.$store.state.user.matauang,
        currency:[{value:'IDR',text:'IDR'}],
        calcVAT:1,
        calcuationVAT : [{ value: 1, text: 'VAT (Auto Calc)' }, { value: 0, text: 'VAT (Manual Calc)' }],
        calcPPh:1,
        calcuationPPH : [{ value: 1, text: 'Nilai PPH(Otomatis)' }, { value: 0, text: 'Nilai PPH(Manual)' }],
        lookupPPH:[],
        daterange:[],
        items:[],itemprice:[],
        ordLines: {
            items: [],
        },
        model: {
            jasa: 0,
            orderdate: moment().format('YYYY-MM-DD'),
            vendor_id: '',
            vendor: '',
            requestno: '',
            ExpectRcv: '',
            remark: '',
            postgroup: '',
            typegroup:'OPEX', 
            matauang:this.$store.state.user.matauang, 
            compcode:this.$store.state.user.compcode,
            invterm: 'COD',
            kodecash: '',
            terms:[], 
            locationdeliv:this.$store.state.user.compaddr},
        tabIndex:0,
    };
},
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
  },
  created: async function(){
        if (this.$route.params.tablekey)  {
          toastr.info('Loading Delivery Detail, please wait')
          try {
            const row = this.$route.params;
            if (moment(row.tglReturn).format('YYYY-MM-DD')<this.$store.state.user.tglaktif){
                this.saveEnabled=false;
            }            
            let awal = moment(row.tglRetur).subtract(6, 'days');
            const akhir = moment(row.tglRetur).subtract(1, 'days');
            while (awal.isBefore(akhir, 'day')) {
                this.daterange.push({kode: awal.format('YYYYMMDD'), tanggal:awal.format('DDMMMYYY')}) ;
                awal.add(1, 'days');
            }
            row.tgl1=moment(row.tglRetur).subtract(6, 'days').format('YYYY-MM-DD');
            row.tgl2=moment(row.tglRetur).format('YYYY-MM-DD');
            for (var key in row) {
                this.model[key] = row[key];
            }
            this.model.tglReturn = moment(row.tglReturn).format('YYYY-MM-DD');
            this.model.customer = `${this.model.CustName} | ${this.model.CustCode}`;
            const ordCustomer = await retur.delivery({ customer_id: this.model.customer_id, 
                                                    tgl1:this.model.tgl1,
                                                    tgl2:this.model.tgl2
                                                    }) ;
            this.ordLines.items = ordCustomer;

            toastr.clear;
          } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
        } else {
            let awal = moment().subtract(6, 'days');
            const akhir = moment().subtract(1, 'days');
            while (awal.isBefore(akhir, 'day')) {
                this.daterange.push({kode: awal.format('YYYYMMDD'), tanggal:awal.format('DDMMMYYY')}) ;
                awal.add(1, 'days');
            }
                this.model.tgl1=moment().subtract(6, 'days').format('YYYY-MM-DD');
                this.model.tgl2=moment().subtract(1, 'days').format('YYYY-MM-DD');
                this.model.tglReturn = moment().format('YYYY-MM-DD');
            this.saveEnabled=false;
        }
  },
  methods: {
    onSelectLkuCustomer: async function (_selected) {
        this.model.customer_id = _selected.customer_id;
        this.model.CustCode = _selected.CustCode;
        this.model.CustName = _selected.CustName;
        this.model.customer = `${_selected.CustName} | ${_selected.CustCode}`;
        this.lkuCustomerShow=false;
    },    
    customerChange: function () {
        this.saveEnabled=false;
        this.ordLines.items=[];
        this.$forceUpdate();
    }, 
    openDelivery: async function(){
        if (this.invalidModel) {
            console.log('validation : ', this.$v.model);
            console.log('model obj : ',this.model);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
            this.saveEnabled=true;            
        } else {
            toastr.info('Loading Delivery Detail, please wait')
            try {
                const ordCustomer = await retur.delivery({ customer_id: this.model.customer_id, 
                                                        tgl1:this.model.tgl1,
                                                        tgl2:this.model.tgl2
                                                        }) ;
                this.ordLines.items = ordCustomer;
                toastr.clear;
                this.saveEnabled=true;

            } catch (error) {
                this.isLoading=false;            
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }        
            }
        }
    },   
    save: async function () {
        if (!this.saveEnabled) {
            toastr.error('View mode cannot be Saved');
            return;
        }
        this.saveEnabled=false;            
        if (this.invalidModel) {
            console.log('validation : ', this.$v.model);
            console.log('model obj : ',this.model);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
            this.saveEnabled=true;            
        } else {
            try {
                this.isLoading=true;            
                this.model.TableName = 'po_header';

                // this.model.DimTableKey = diisi dari PR/SR;
                    // this.model.customer_id = this.model.customer_id || '';
                    // this.model.orderno = this.model.orderno || '';
                    const row = {};
                    for (var key in this.model) {
                        row[key] = this.model[key];
                    }
                    // row.expectreceipt = row.expectreceipt ? moment(row.expectreceipt).format('YYYY-MM-DD') : undefined;
                    let lineno=1;
                    row.lines = this.ordLines.items.reduce((newArr, item) => {
                        if ((item.itemno || '') != '') {
                            item.lineno = lineno;
                            newArr.push(item);
                            lineno += 1;
                        }
                        return newArr;
                    }, []);
                    if (row.lines.length>0) {
                        await retur.save(row);
                        this.isLoading=false;            
                        toastr.success(`Save Successfully`, "Retur Customer",10000);
                        this.close();
                    } else {
                        toastr.error('Please fill at least 1(one) Order Detail', 'ERROR MESSAGE');
                        this.isLoading=false;            
                    }
            } catch (error) {
                this.isLoading=false;            
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }        
            }

        }
    },

    calcTotQty: function(record){
        setTimeout(() => {
            record.quantity=0;
            this.daterange.forEach((kol)=>{
                record.quantity += parseFloat(record[`Q${kol.kode}`] || 0) ;
            });
        }, 100);
        this.calcPrice(record);
    },
    calcTotalDtlOrder: function () {
        this.calcVAT = this.calcVAT || 1;
        let nilaippn = 0;
        let ttlnetto = 0;
        let ttlamtdue = 0;
        // let totalpph = 0;
        this.ordLines.items.forEach( function (trx) {
            if (trx.itemno) {
                ttlnetto += (trx.nilai || 0);
                nilaippn += (trx.nilaippn || 0);
                ttlamtdue = ttlnetto + (nilaippn || 0);
                // totalpph += parseFloat(trx.nilaipph || 0);
            }
        });
        this.model.ttlnetto = ttlnetto;
        if (this.calcVAT == 1){
            this.model.nilaippn = nilaippn;
        }
        this.model.ttlamtdue = ttlamtdue;
        // this.model.totalpph = totalpph;
    },    
    calcAmountDue : function() {
        this.model.ttlamtdue = parseFloat(this.model.ttlnetto || 0) + parseFloat(this.model.nilaippn || 0);
    }, 
    calcTaxes : function(record) {
        record.nilainett = parseFloat(record.nilai) - parseFloat(record.nilaidisc || 0);
        record.dpp = parseFloat(record.nilai) * parseFloat(record.dppnlain) / 100;
        if (record.kenappn == 1) {
            record.ppn = record.ppn || 11;
        } else {
        // if ((record.ppn || 0) == 0 ) {
            // record.kenappn = 0;
            record.dpp = 0;
            record.ppn = 0;
        }
        // if (this.model.grossup == 1)
        //     record.dpp = record.dpp * (100 / (100 - record.pph));

        record.nilaippn = parseFloat(record.ppn) / 100 * record.dpp;
        record.nilaidue = record.nilainett + record.nilaippn;
    },

    calcPrice : function(record) {
        record.nilai = parseFloat(record.quantity) * parseFloat(record.unitprice);
        if (record.disc > 0) {
            record.nilaidisc = record.disc * record.nilai / 100.0;
        };
        // this.ordLinesObj.nilainett = this.ordLinesObj.nilai - parseFloat(this.model.nilaidisc || 0);
        this.calcTaxes(record);
    },
    calcPriceDelay : function(record) {
        setTimeout(() => {
            record.nilai = parseFloat(record.quantity) * parseFloat(record.unitprice);
            if (record.disc > 0) {
                record.nilaidisc = record.disc * record.nilai / 100.0;
            };
            
        }, 100);
    },

    tanggalBerubah: function(){
        this.tahun=moment(this.model.tanggal).format('YYYY');
    },

    close(){
    //   console.log('this.$store.state.prevRoute.name : ',this.$store.state.prevRoute.name);
      if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name !== 'bakery.receivingcustomerfrm')) {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
        // router.push({name:'payable.apinv'});
          router.push("home");
      }
    }
  }
};
</script>
